<div class="chaneNamePopup">
    <div class="name">
        <p>{{message}}</p>
        <p class="message2">{{message2}}</p>
    </div>
    <div class="btns">
        <div class="cancel pointer" (click)="cancel()">
            <p  translate>btns.cancel</p>
        </div>
        <div class="save pointer" (click)="save()">
            <p  *ngIf="!btnActive" translate>btns.delete</p>
            <p *ngIf="btnActive">{{btnActive}}</p>
        </div>
    </div>
</div>